export default "__VITE_ASSET___AX56Why__"